import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProjectEmbed from "./ProjectEmbed";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function truncate(s, max = 320) {
  if (!s) return "";
  const t = s.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max).trim()}…`;
}

function ProjectCards(props) {
  const { slug, title, summary, techTags = [], link } = props;

  return (
    <Link
      to={`/project/${slug}`}
      className="project-list-card-link"
      aria-label={`${title} — view project details`}
    >
      <article className="project-list-card-wide">
        {/* Captures clicks across the whole card (iframe otherwise steals hits). */}
        <span
          className="project-list-card-hit-layer"
          aria-hidden="true"
        />
        <Row className="g-0 project-list-card-top align-items-stretch">
          <Col xs={12} md={6} lg={7} className="project-list-card-embed-col">
            <div className="project-list-card-embed-wrap">
              <ProjectEmbed
                src={link}
                className="project-list-card-embed"
                linkLabel={title}
                scaledFit
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} className="project-list-card-intro-col">
            <div className="project-list-card-intro">
              <h2 className="project-list-card-title">{title}</h2>
              <p className="project-list-card-tagline project-list-card-tagline--intro">
                {truncate(summary)}
              </p>
            </div>
          </Col>
        </Row>

        <div className="project-list-card-divider" role="separator" aria-hidden="true" />

        <div className="project-list-card-content project-list-card-bottom">
          <div className="project-list-card-row project-list-card-row--bottom">
            <ul className="project-tech-bullets" aria-label="Technologies used">
              {techTags.map((tag) => (
                <li key={tag}>
                  <span className="project-tech-pill">{tag}</span>
                </li>
              ))}
            </ul>
            <div className="project-list-card-aside">
              <span className="btn btn-primary project-list-card-btn">
                View details
              </span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}

export default ProjectCards;
